import { ArrowRight } from 'lucide-react';

import { LegalPage } from './LegalPage';

import { AppleMark } from '@/components/icons/AppleMark';
import { Button } from '@/components/ui/button';
import { APP_STORE_URL } from '@/lib/constants';

interface PreviewRouteProps {
  previewId?: string;
  onBackHome: () => void;
}

export function PreviewRoute({ previewId, onBackHome }: PreviewRouteProps) {
  return (
    <LegalPage
      title={previewId ? 'Open Preview in Michelangelo' : 'Preview'}
      updated="—"
      onBackHome={onBackHome}
    >
      <div className="space-y-4">
        <p className="text-muted-foreground">
          {previewId ? (
            <>
              You&apos;re viewing a shared Michelangelo preview:{' '}
              <span className="text-foreground font-medium">{previewId}</span>
            </>
          ) : (
            <>This preview link is missing an ID.</>
          )}
        </p>

        <div className="flex flex-col sm:flex-row gap-2">
          <Button
            className="leading-none"
            disabled={!previewId}
            onClick={() => {
              if (!previewId) return;
              window.location.href = `michelangelo://preview/${encodeURIComponent(previewId)}`;
            }}
          >
            Open in app <ArrowRight className="size-4" />
          </Button>
          <Button className="leading-none" variant="secondary" asChild>
            <a href={APP_STORE_URL} target="_blank" rel="noreferrer">
              <AppleMark className="size-4" />
              Download for iOS <ArrowRight className="size-4" />
            </a>
          </Button>
        </div>

        <div className="rounded-xl border border-border/70 bg-card/40 p-4 text-sm text-muted-foreground">
          If the app is installed, opening this link on iOS should take you directly to Michelangelo
          via Universal Links.
        </div>
      </div>
    </LegalPage>
  );
}
